const LOCAL_STORAGE_KEY = 'plooto-redux-state'

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (serializedState === null) {
      return undefined;
    }

    const state = JSON.parse(serializedState)
    return state
  } catch (err) {
    console.error('failed lading redux state from local-storate', err)
    return undefined;
  }
};

const cleanBeforeSerialize = (stateToSerialize) => {
  delete stateToSerialize.solutionsContainer
  delete stateToSerialize.renderedSolution
}

export const saveState = (state) => {
  try {
    const stateToSerialize = { ...state }
    cleanBeforeSerialize(stateToSerialize)
    const serializedState = JSON.stringify(stateToSerialize);
    localStorage.setItem(LOCAL_STORAGE_KEY, serializedState);
  } catch (err) {
    console.error('failed saving redux state to local-storate', err)
  }
};